import { InsuranceType, PaymentMethod } from "@comparaonline/cicl-funnel-schema";
import { Offer } from "@comparaonline/offers-models";
import { getConfig } from "../../../../config/app";
import { MAX_INSTALLMENTS_COUNT, PAYMENT_METHODS_PRODUCT_ATTR_CODE } from "../constants";

export interface AllowedPaymentMethod {
  amount: number;
  name: PaymentMethod;
  installments: number;
}

type GetPaymentMethodsByOffer<Response extends PaymentMethod> = (
  offer: Offer
) => Response[] | undefined;

export const getPaymentMethodsByOffer: GetPaymentMethodsByOffer = offer => {
  const { productAttributes } = offer.product;
  const productAttribute = productAttributes.find(
    pa => pa.entity.code === PAYMENT_METHODS_PRODUCT_ATTR_CODE
  );

  return productAttribute
    ? productAttribute.value.map(({ name }: { name: PaymentMethod }) => name)
    : undefined;
};

export const getPaymentMethosAllowedByInsuranceType = (
  insuranceType: InsuranceType,
  offer: Offer,
  isThirdPartySponsor: boolean
): AllowedPaymentMethod[] => {
  const paymentMethods = isThirdPartySponsor
    ? [PaymentMethod.ThirdPartySponsor]
    : getPaymentMethodsByOffer(offer) ||
      getConfig("checkout.paymentMethodsAllowList")[insuranceType];
  const {
    mainAttribute: {
      value: { amount }
    }
  } = offer.product;

  return paymentMethods.map((name: PaymentMethod) => ({
    name,
    amount:
      name === PaymentMethod.WebPay || isThirdPartySponsor
        ? amount * MAX_INSTALLMENTS_COUNT
        : amount,
    installments: name === PaymentMethod.OneClick ? MAX_INSTALLMENTS_COUNT : 0
  }));
};
